import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebaseConfig.js'; // Importa auth y db desde firebaseConfig
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate , Link} from 'react-router-dom';

const FailurePage = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  
  useEffect(() => {
    const logFailure = async () => {
      // Obtener el UID del usuario autenticado
      const user = auth.currentUser;
      if (!user) {
        setMessage("No se pudo verificar al usuario autenticado.");
        setLoading(false);
        return;
      }

      const userId = user.uid; // Obtener el UID del usuario autenticado

      // Obtener el monto real pagado desde los parámetros de la URL
      const amountPaid = new URLSearchParams(window.location.search).get('amount');
      if (!amountPaid) {
        setMessage('Monto no válido.');
        setLoading(false);
        return;
      }

      try {
        // Agregar el registro de la transacción fallida en la colección "saldos"
        const saldosRef = collection(db, 'saldos');
        await addDoc(saldosRef, {
          userId,
          monto: parseFloat(amountPaid),
          estado: 'fallido', // Estado de la transacción
          timestamp: new Date(), // Timestamp del fallo
        });

        setMessage('Transacción fallida. Por favor, intenta de nuevo más tarde.');
      } catch (error) {
        setMessage('Error al registrar el fallo de la transacción.');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    logFailure();
  }, []);

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <h1 style={{ color: 'red' }}>¡Pago Fallido!</h1>
      <p>{message}</p>
      <Link to="/" className="button">Volver al Inicio</Link>
    </div>
  );
};

export default FailurePage;
